var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("HMI PHYSICIAN-IN-CHARGE (PIC)")]),_c('h4',[_vm._v(" An HMI primary care physician who is designated as the team leader of the group of HMI accredited doctors at an HMI accredited hospital. The PIC is always the first one whom the HMI members will see/visit with regard to their medical availments. ")])])
}]

export { render, staticRenderFns }